require('./mortgageRequestSimpleNoteSuccessful.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { getLastNChars } = require('utilities/stringHelper');
const { chain } = require('lodash');
const { connect } = require('react-redux');

// @ commons
const { formatText } = require('core/i18n').i18n;

//@ constants
const { ESTATES_TYPE } = require('constants/mortgageRequestHolderData.js');
const { SECOND_STEP, EURO_TEXT } = require('constants/index');

// @ components
const MortgageRequestSimpleNoteAddress = require('components/mortgageRequest/mortgageRequestSimpleNote/mortgageRequestSimpleNoteAddressFormat/mortgageRequestSimpleNoteAddressFormat');
const MortgageRequestCurrencyHelp = require('components/mortgageRequest/mortgageRequestCurrencyHelp/mortgageRequestCurrencyHelp.js');
const MortgageRequestSimpleNoteConstructions = require(
    'components/mortgageRequest/mortgageRequestSimpleNote/mortgageRequestSimpleNoteConstructions/mortgageRequestSimpleNoteConstructions');

// @utilities
const { getEstatesToRequest } = require('utilities/mortgageHelper');

class MortgageRequestSimpleNoteSuccessful extends React.Component {
    getAccount() {
        const {
            immSimpleNoteRequest,
            immAccounts
        } = this.props;
        const accountId = immSimpleNoteRequest.getIn(['steps', SECOND_STEP, 'accountId']);
        const immAccount = immAccounts.getIn(['byId', accountId], '').toJS();
        return {
            accountIBAN: immAccount.iban,
            accountType: immAccount.catalogData.product
        }
    }

    getStoragesAndGarages() {
        const {
            inmueblesState,
            mortgageRequestSimpleNoteValue,
            summaryDocumentation
        } = this.props;
        const data = {
            storageRooms: '',
            garages: '',
            totalSimpleNote: 0,
            valueSimpleNote: 0
        };
        const stateValueSimpleNote = mortgageRequestSimpleNoteValue.toJS();
        const valueSimpleNote = stateValueSimpleNote.simpleNoteCost;
        const estateEstatesList = inmueblesState.get('list').toJS();
        const propertyData = chain(estateEstatesList).filter(estate => estate.tipoBien === ESTATES_TYPE.VIVIENDA).last().value();
        const simpleNotesToRequest = getEstatesToRequest(inmueblesState, summaryDocumentation);
        const totalSimpleNotes = simpleNotesToRequest.length;

        data.storageRooms = parseInt(propertyData.storageRooms) > 0 ? propertyData.storageRooms : null;
        data.garages = parseInt(propertyData.garages) > 0 ? propertyData.garages : null;
        data.totalSimpleNote = totalSimpleNotes;
        data.valueSimpleNote = data.totalSimpleNote * valueSimpleNote;

        return data;
    }

    buildEstatesLabel(totalStorageRooms, totalGarages) {
        const garagesText = `${totalGarages} ${formatText('mortgageRequestSimpleNoteAddress-garages')}`;
        const storageRoomText = `${totalStorageRooms} ${formatText('mortgageRequestSimpleNoteAddress-storageRoom')}`;

        if (totalStorageRooms && totalGarages) {
            return formatText('mortgageRequestSimpleNoteSuccessfulResult-includesBothLabel', [storageRoomText, garagesText]);
        } else if (totalStorageRooms) {
            return formatText('mortgageRequestSimpleNoteSuccessfulResult-includesLabel', [storageRoomText]);
        } else if (totalGarages) {
            return formatText('mortgageRequestSimpleNoteSuccessfulResult-includesLabel', [garagesText]);
        }
    }

    buildLivingPlacePanel(data) {
        const {
            simpleNoteRequested,
            simpleNoteTotalCost,
            account,
            infoStorageAndGarages,
            completeItem
        } = data;
        const accountLastNumbers = getLastNChars(account.accountIBAN.toString());
        const accountType = account.accountType.toLowerCase();
        const params = {
            currency: simpleNoteTotalCost,
            symbol: EURO_TEXT,
        }
        const simpleNoteTotalCostFormmated = MortgageRequestCurrencyHelp(params);
        const labelStoragesGarages = this.buildEstatesLabel(infoStorageAndGarages.storageRooms, infoStorageAndGarages.garages);

        return (
            <div className="row">
                <div className="col-xs-6">
                    <MortgageRequestSimpleNoteAddress
                        completeItem={completeItem}
                        highlightLivingPlaceLabel={false}
                    />
                    <div className="row mortgage-request-simple-note-result-successful-living-place--margin-top">
                        <div className="col-xs-12">
                            <span className="mortgage-request-simple-note-result-successful-living-place__title">
                                {labelStoragesGarages}
                            </span>
                        </div>
                    </div>
                </div>
                <div className="col-xs-6">
                    <div className="row">
                        <div className="col-xs-12">
                            <span className="mortgage-request-simple-note-result-successful-living-place__title">{formatText('mortgageRequestSimpleNoteSuccessfulResult-simpleNotesCountLabel')}</span>
                            <span className="mortgage-request-simple-note-result-successful-living-place__value">{simpleNoteRequested}</span>
                        </div>
                    </div>
                    <div className="row mortgage-request-simple-note-result-successful-living-place--margin-top">
                        <div className="col-xs-12">
                            <span className="mortgage-request-simple-note-result-successful-living-place__title">{formatText('mortgageRequestSimpleNoteSuccessfulResult-simpleNotesTotalPriceLabel')}</span>
                            <span className="mortgage-request-simple-note-result-successful-living-place__value">{simpleNoteTotalCostFormmated}</span>
                        </div>
                    </div>
                    <div className="row mortgage-request-simple-note-result-successful-living-place--margin-top">
                        <div className="col-xs-12">
                            <span className="mortgage-request-simple-note-result-successful-living-place__title">{formatText('mortgageRequestSimpleNoteSuccessfulResult-accountLabel')}</span>
                            <span className="mortgage-request-simple-note-result-successful-living-place__value--capitalize">{accountType} {accountLastNumbers}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const clientAccount = this.getAccount();
        const stateEstatesList = this.props.inmueblesState.get('list').toJS();
        const propertyData = chain(stateEstatesList).filter(estate => estate.tipoBien === ESTATES_TYPE.VIVIENDA).last().value();
        const garagesAndStorageRoomsData = this.getStoragesAndGarages();

        const livingPlaceData = {
            simpleNoteRequested: garagesAndStorageRoomsData.totalSimpleNote,
            simpleNoteTotalCost: garagesAndStorageRoomsData.valueSimpleNote,
            account: clientAccount,
            infoStorageAndGarages: garagesAndStorageRoomsData,
            completeItem: propertyData,
            garagesAndStorageRoomsIncluded: this.props.inmueblesState
        };

        return (
            <div>
                {this.buildLivingPlacePanel(livingPlaceData)}
                <MortgageRequestSimpleNoteConstructions
                    immEstates={livingPlaceData.garagesAndStorageRoomsIncluded}
                />
                {this.props.showMessages && (
                    <div className="row mortgage-request-simple-note-result-successful__messages">
                        <div className="col-xs-11 mortgage-request-simple-note-result-successful__messages-first">
                            <p>{formatText('mortgageRequestSimpleNoteSuccessfulResult-message1')}</p>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

MortgageRequestSimpleNoteSuccessful.propTypes = {
    showMessages: PropTypes.bool,
    inmueblesState: PropTypes.object,
    immAccounts: PropTypes.object.isRequired,
    immSimpleNoteRequest: PropTypes.object.isRequired,
    resquestSimpleNoteUnitValue: PropTypes.func,
    mortgageRequestSimpleNoteValue: PropTypes.object,
    summaryDocumentation: PropTypes.object
};

MortgageRequestSimpleNoteSuccessful.defaultProps = {
    showMessages: true
};

module.exports = connect(state => ({
    inmueblesState: state.mortgageRequestInmuebles,
    immSimpleNoteRequest: state.mortgageRequestSimpleNoteRequest,
    immAccounts: state.accounts,
    mortgageRequestState: state.mortgageRequestState,
    mortgageRequestSimpleNoteValue: state.mortgageRequestPayment,
    estatesState: state.mortgageRequestEstatesData,
    summaryDocumentation: state.mortgageRequestSummaryDocumentation
}), null)(MortgageRequestSimpleNoteSuccessful);
